import styled from 'styled-components'

export default styled.div`
  padding: 10px 12px 5px 15px;
  margin: 0;
  width: 100%;
  heigth: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;
`